import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { CLASS_COMPONENT } from '../../common';

export const ActionTextButton = styled.button.attrs<{ $color: string }>({
  className: createReadableClass({
    component: CLASS_COMPONENT,
    element: 'action-text-button'
  })
})`
  border: none;
  outline: none;
  padding: 0;
  background: transparent;

  color: ${({ $color }) => $color};
  cursor: pointer;
  text-decoration: underline;
`;
